const supportedTimezones = {
  EuropeLondon: "Europe/London",
} as const;

export default supportedTimezones;
